export default __webpack_public_path__ + "static/6-06d7e5cbebfe610c200e688a9cd4ad16.webp";